<div class="row centered">
    <div class="col-md-6 message">
        {{message()}}
        <button class="btn" (click)="clearMessage()">Ok</button>
    </div>
</div>